/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "دیروز",
      "0": "اَمروز",
      "1": "فِردا",
      "future": {
        "other": "{0} روز دله"
      },
      "past": {
        "other": "{0} روز پیش"
      }
    },
    "day-narrow": {
      "-1": "دیروز",
      "0": "اَمروز",
      "1": "فِردا",
      "future": {
        "other": "{0} روز دله"
      },
      "past": {
        "other": "{0} روز پیش"
      }
    },
    "day-short": {
      "-1": "دیروز",
      "0": "اَمروز",
      "1": "فِردا",
      "future": {
        "other": "{0} روز دله"
      },
      "past": {
        "other": "{0} روز پیش"
      }
    },
    "hour": {
      "0": "this hour",
      "future": {
        "other": "{0} ساعِت دله"
      },
      "past": {
        "other": "{0} ساعِت پیش"
      }
    },
    "hour-narrow": {
      "0": "this hour",
      "future": {
        "other": "{0} ساعت دله"
      },
      "past": {
        "other": "{0} ساعت پیش"
      }
    },
    "hour-short": {
      "0": "this hour",
      "future": {
        "other": "{0} ساعت دله"
      },
      "past": {
        "other": "{0} ساعت پیش"
      }
    },
    "minute": {
      "0": "this minute",
      "future": {
        "other": "{0} دقیقه دله"
      },
      "past": {
        "other": "{0} دَقه پیش"
      }
    },
    "minute-narrow": {
      "0": "this minute",
      "future": {
        "other": "{0} دَقه دله"
      },
      "past": {
        "other": "{0} دَقه پیش"
      }
    },
    "minute-short": {
      "0": "this minute",
      "future": {
        "other": "{0} دَقه دله"
      },
      "past": {
        "other": "{0} دَقه پیش"
      }
    },
    "month": {
      "-1": "ماه قبل",
      "0": "این ماه",
      "1": "ماه ِبعد",
      "future": {
        "other": "{0} ماه دله"
      },
      "past": {
        "other": "{0} ماه پیش"
      }
    },
    "month-narrow": {
      "-1": "ماه قبل",
      "0": "این ماه",
      "1": "ماه ِبعد",
      "future": {
        "other": "{0} ماه دله"
      },
      "past": {
        "other": "{0} ماه پیش"
      }
    },
    "month-short": {
      "-1": "ماه قبل",
      "0": "این ماه",
      "1": "ماه ِبعد",
      "future": {
        "other": "{0} ماه دله"
      },
      "past": {
        "other": "{0} ماه پیش"
      }
    },
    "nu": [
      "arabext"
    ],
    "quarter": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "{0} ربع دله"
      },
      "past": {
        "other": "{0} ربع پیش"
      }
    },
    "quarter-narrow": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "{0} ربع دله"
      },
      "past": {
        "other": "{0} ربع پیش"
      }
    },
    "quarter-short": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "{0} ربع دله"
      },
      "past": {
        "other": "{0} ربع پیش"
      }
    },
    "second": {
      "0": "now",
      "future": {
        "other": "{0} ثانیه دله"
      },
      "past": {
        "other": "{0} ثانیه پیش"
      }
    },
    "second-narrow": {
      "0": "now",
      "future": {
        "other": "{0} ثانیه دله"
      },
      "past": {
        "other": "{0} ثانیه پیش"
      }
    },
    "second-short": {
      "0": "now",
      "future": {
        "other": "{0} ثانیه دله"
      },
      "past": {
        "other": "{0} ثانیه پیش"
      }
    },
    "week": {
      "-1": "قبلی هفته",
      "0": "این هفته",
      "1": "بعدی هفته",
      "future": {
        "other": "{0} هفته دله"
      },
      "past": {
        "other": "{0} هفته پیش"
      }
    },
    "week-narrow": {
      "-1": "قبلی هفته",
      "0": "این هفته",
      "1": "بعدی هفته",
      "future": {
        "other": "{0} هفته دله"
      },
      "past": {
        "other": "{0} هفته پیش"
      }
    },
    "week-short": {
      "-1": "قبلی هفته",
      "0": "این هفته",
      "1": "بعدی هفته",
      "future": {
        "other": "{0} هفته دله"
      },
      "past": {
        "other": "{0} هفته پیش"
      }
    },
    "year": {
      "-1": "پارسال",
      "0": "امسال",
      "1": "سال دیگه",
      "future": {
        "other": "{0} سال دله"
      },
      "past": {
        "other": "{0} سال پیش"
      }
    },
    "year-narrow": {
      "-1": "پارسال",
      "0": "امسال",
      "1": "سال دیگه",
      "future": {
        "other": "{0} سال دله"
      },
      "past": {
        "other": "{0} سال پیش"
      }
    },
    "year-short": {
      "-1": "پارسال",
      "0": "امسال",
      "1": "سال دیگه",
      "future": {
        "other": "{0} سال دله"
      },
      "past": {
        "other": "{0} سال پیش"
      }
    }
  },
  "locale": "mzn"
})
}
